import { useEffect, useState } from 'react';

import { Observable, Observer, Subject, takeUntil } from 'rxjs';

export const useUnmountSubject = () => {
    const [unmountSubject] = useState(new Subject<void>());
    useEffect(() => {
        return () => {
            unmountSubject.next();
            unmountSubject.complete();
        };
    }, []);

    return unmountSubject;
};

export const useUnmount = () => {
    const [unmountSubject] = useState(new Subject<void>());

    useEffect(() => {
        return () => {
            unmountSubject.next();
            unmountSubject.complete();
        };
    }, []);

    return function boilerplate<T>(
        observable: Observable<T>,
        observerOrNext?: Partial<Observer<T>> | ((value: T) => void),
        onError?: (err: any) => void,
    ) {
        const newObserver = (f: (value: T) => void) => ({ next: f, error: onError });
        const partialObserverOrUndefined =
            typeof observerOrNext === 'function' ? newObserver(observerOrNext) : observerOrNext;
        const pipedObservable = observable.pipe(takeUntil(unmountSubject));
        return partialObserverOrUndefined
            ? pipedObservable.subscribe(partialObserverOrUndefined)
            : pipedObservable.subscribe();
    };
};
